import { Events } from 'ionic-angular';
import { Injectable } from '@angular/core';

@Injectable()
export class Near {
  constructor(private events: Events) {}

  get(map) {
    let visibles = [];
    let lines = [];
    let bounds = map.map.getBounds();

    for (let marker of map.markers) {
      if (bounds && bounds.contains(marker.getPosition())) {
        visibles.push(marker);

        for (let line of marker.lines) {
          let id = line.id;

          // Test
          if (!line.markers) {
            line.markers = [];
          }

          line.markers.push(marker);

          if (typeof lines[id] === 'undefined') {
            lines[id] = [];
          }

          lines[id].push(line);
        }
      }
    }

    // Let's retrieve unique lines
    let uniques = [];
    for (let array in lines) {
      uniques.push({
        code: lines[array][0].code,
        routes: this.unique(lines[array], 'direction_id').sort((a, b) => a.direction_id > b.direction_id)
      });
    }

    // Distance calculation from the center to keep only the nearest stop
    let middle = map.map.getCenter();

    for (let line of uniques) {
      for (let route of line.routes) {
        let nearest = this.findNearest(middle, route.markers);
        route.nearest = nearest;
      }
    }

    // Sort Lines
    uniques = uniques.sort((a, b) => {
      return +(a['code'] > b['code']) || +(a['code'] === b['code']) - 1;
    });
    this.events.publish('carpostal:near:get', uniques);
  }

  findNearest(middle, markers, nearest = null) {
    if (nearest === null) {
      nearest = markers[0];
    }

    for (let marker of markers) {
      var a = google.maps.geometry.spherical.computeDistanceBetween(middle, marker.getPosition());
      var b = google.maps.geometry.spherical.computeDistanceBetween(middle, nearest.getPosition());

      if (a < b) {
        nearest = marker;
        this.findNearest(middle, markers, nearest);
      }
    }

    return nearest;
  }

  unique(array, property) {
    let seen = [],
      unique = array.slice();

    for (let key in array) {
      let item = array[key];

      if (seen.indexOf(item[property]) < 0) {
        seen.push(item[property]);
      } else {
        let index = unique.indexOf(item);
        unique.splice(index, 1);
      }
    }

    return unique;
  }
}
